import { Button, ModalRedirect, WrapperGeneral } from "components";

import { IcoExternalLink } from "assets/icons";
import {
	B3Listed,
	GlobalPact,
	Gptw23,
	Gptw24,
	LinkedinLogo,
	LogoWhite,
	Ods,
	YoutubeLogo
} from "assets/images";
import { useCallback, useState } from "react";

import { Constants } from "appConstants";
import EulaModal, { EulaSections } from "components/EulaModal";
import { AuthService } from "services/auth";
import "./styles.scss";

export default function Footer() {
	const [redirectModalOpen, setRedirectModalOpen] = useState<boolean>(false);
	const [isEulaModalOpen, setIsEulaModalOpen] = useState<boolean>(false);
	const [selectedEulaSection, setSelectedEulaSection] = useState<EulaSections>(
		EulaSections.TERMS
	);
	const extAuthService = new AuthService();

	const openEulaSection = useCallback((section: EulaSections) => {
		setIsEulaModalOpen(true);
		setSelectedEulaSection(section);
	}, []);

	const handleRedirect = () => {
		setRedirectModalOpen(true);
		setTimeout(() => extAuthService.loginB2C(), 1000);
	};

	return (
		<>
			<div className="container-footer ">
				<div className="content-list-links">
					<WrapperGeneral>
						<div className="links">
							<h3 className="headline-3">Faixa de Domínio</h3>
							<Button onClick={handleRedirect} kind="link" hierarchy="ghost">
								Acessar plataforma <IcoExternalLink size="16" color="#fff" />
							</Button>
							<Button kind="link" hierarchy="ghost" onClick={handleRedirect}>
								Acompanhar minhas solicitações
								<IcoExternalLink size="16" color="#fff" />
							</Button>
						</div>
						<div className="links">
							<h3 className="headline-3">Institucional</h3>
							<Button kind="link" hierarchy="ghost">
								<a
									href="https://www.motiva.com.br/"
									target="_blank"
									rel="noreferrer"
								>
									Motiva
								</a>
								<IcoExternalLink size="16" color="#fff" />
							</Button>
							<Button kind="link" hierarchy="ghost">
								<a
									href="https://rodovias.motiva.com.br/"
									target="_blank"
									rel="noreferrer"
								>
									Motiva Rodovias
								</a>
								<IcoExternalLink size="16" color="#fff" />
							</Button>
						</div>
						<div className="links">
							<h3 className="headline-3">Fale Conosco</h3>
							<Button kind="link" hierarchy="ghost">
								<a
									href="https://www.motiva.com.br/contatos/"
									target="_blank"
									rel="noreferrer"
								>
									Contatos Motiva
								</a>
								<IcoExternalLink size="16" color="#fff" />
							</Button>
							<Button kind="link" hierarchy="ghost">
								<a
									href="https://www.motiva.com.br/contatos/#347ad7372a9dd13317e129a22da0edd1"
									target="_blank"
									rel="noreferrer"
								>
									Ouvidoria
								</a>
								<IcoExternalLink size="16" color="#fff" />
							</Button>
							<Button kind="link" hierarchy="ghost">
								<a
									href="https://canalconfidencial.com.br/canalconfidencialmotiva/"
									target="_blank"
									rel="noreferrer"
								>
									Canal Confidencial
								</a>
								<IcoExternalLink size="16" color="#fff" />
							</Button>
						</div>
					</WrapperGeneral>
				</div>
				<div className="content-social">
					<WrapperGeneral>
						<div className="social-media">
							<a
								href="https://www.linkedin.com/company/motivamobilidade/"
								target="_blank"
								rel="noreferrer"
							>
								<img src={LinkedinLogo} alt="Logo LinkedIn" />
							</a>
							<a
								href="https://www.youtube.com/@motivamobilidade"
								target="_blank"
								rel="noreferrer"
							>
								<img src={YoutubeLogo} alt="Logo YouTube" />
							</a>
						</div>
					</WrapperGeneral>
				</div>
				<div className="content-about">
					<WrapperGeneral>
						<div className="links-shared">
							<div className="logo-address-link">
								<div className="logo">
									<img src={LogoWhite} alt="Logo Motiva" />
								</div>
								<div className="address-link">
									<address className="body-1 not-italic">
										<br />
										Edifício Eldorado Business Tower - Av. Dra. Ruth Cardoso,
										8.501 - 5º andar, Pinheiros - São Paulo - SP - CEP:
										05425-070 • © 2025 Motiva
									</address>
									<ul>
										<li>
											<Button
												kind="link"
												hierarchy="ghost"
												onClick={() => openEulaSection(EulaSections.TERMS)}
											>
												Termos de uso
											</Button>
										</li>
										<li>•</li>
										<li>
											<Button
												kind="link"
												hierarchy="ghost"
												onClick={() => openEulaSection(EulaSections.PRIVACY)}
											>
												Política de privacidade
											</Button>
										</li>
										<li>•</li>
										<li>
											<Button
												kind="link"
												hierarchy="ghost"
												onClick={() => openEulaSection(EulaSections.COOKIES)}
											>
												Política de cookies
											</Button>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</WrapperGeneral>
				</div>
				<div className="content-certifications">
					<WrapperGeneral>
						<div className="social-media">
							<a
								href="https://www.linkedin.com/company/motivamobilidade/"
								target="_blank"
								rel="noreferrer"
							>
								<img src={LinkedinLogo} alt="Logo LinkedIn" />
							</a>
							<a
								href="https://www.youtube.com/@motivamobilidade"
								target="_blank"
								rel="noreferrer"
							>
								<img src={YoutubeLogo} alt="Logo YouTube" />
							</a>
						</div>
						<div className="certifications">
							<img src={GlobalPact} alt="Pacto Global" />
							<img src={B3Listed} alt="B3" />
							<img src={Ods} alt="ODS" />
							<img src={Gptw23} alt="GPTW 2023" />
							<img src={Gptw24} alt="GPTW 2024" />
						</div>
					</WrapperGeneral>
				</div>
				<div className="content-captcha">
					<WrapperGeneral>
						<p className="body-1">
							Este site é protegido pelo reCAPTCHA e pela{" "}
							<a
								href="https://policies.google.com/privacy"
								className="underline hover:text-gray-200"
								target="_blank"
								rel="noopener noreferrer"
							>
								Política de privacidade
							</a>{" "}
							e{" "}
							<a
								href="https://policies.google.com/terms"
								className="underline hover:text-gray-200"
								target="_blank"
								rel="noopener noreferrer"
							>
								Termos de serviço
							</a>{" "}
							do Google.
						</p>
					</WrapperGeneral>
				</div>
				<ModalRedirect
					isOpen={redirectModalOpen}
					text={Constants.textRedirectLogin}
				/>
			</div>
			<EulaModal
				displayedPolicy={selectedEulaSection}
				isOpen={isEulaModalOpen}
				onClose={() => setIsEulaModalOpen(false)}
			/>
		</>
	);
}
